import { isValidFilter, compareByTitle } from '@/utils/resultsHelper';
import { isAllowed } from './typeAheadSearch';

export const Actions = (
  about,
  newRole,
  defaultRole,
  defaultApproval,
  newToken,
) => [
  {
    name: 'role.new',
    onClick: newRole,
    keywords: ['role', 'security', 'rbac', 'permission', 'admin', 'new', 'create'],
    permissions: [['roles.create']],
  },
  {
    name: 'default.role',
    onClick: defaultRole,
    keywords: ['default', 'roles', 'admin'],
    permissions: [['roles.read', 'configurations.update']],
  },
  {
    name: 'default.approval',
    onClick: () => defaultApproval(),
    keywords: ['auto', 'default', 'approval', 'admin'],
    permissions: [['users.read', 'configurations.update']],
  },
  {
    name: 'token.new',
    onClick: newToken,
    keywords: ['api', 'program', 'token', 'auth', 'new', 'create'],
    permissions: [['users.token_create']],
  },
  {
    name: 'about',
    onClick: () => about({ show: true }),
    keywords: ['swagger', 'doc', 'api', 'program', 'version', 'token', 'about'],
  },
];

export const filterActions = (
  { query, userPermissions },
  about,
  newRole,
  defaultRole,
  defaultApproval,
  newToken,
) => Actions(
  about,
  newRole,
  defaultRole,
  defaultApproval,
  newToken,
).filter(({ keywords, permissions }) => keywords.some(
  (keyword) => keyword.includes(query.toLowerCase()) && isAllowed(permissions, userPermissions),
));

const actionsToPerform = (
  state,
  about,
  newRole,
  defaultRole,
  defaultApproval,
  newToken,
  intl,
) => filterActions(state, about, newRole, defaultRole, defaultApproval, newToken).map((action) => ({
  title: intl.formatMessage({ id: `search.action.${action.name}.title` }),
  description: intl.formatMessage({ id: `search.action.${action.name}.description` }),
  onClick: action.onClick,
  permission: action.permission,
})).sort(compareByTitle);

export const actionResults = (
  state,
  intl,
  about,
  newRole,
  defaultRole,
  defaultApproval,
  newToken,
) => {
  const results = isValidFilter(state.query, { requiresFilter: true, minFilterLength: 2 })
    ? actionsToPerform(state, about, newRole, defaultRole, defaultApproval, newToken, intl)
    : [];

  if (results.length === 0) {
    return null;
  }

  return ({ actions: { name: intl.formatMessage({ id: 'search.action.category' }), results } });
};
